import { SearchResult } from '#server/models';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  ResultCardWebPage,
  Badge,
  HighlightedText,
} from '@/components';
import { cn } from '@/utils';

export interface PageResultCardProps {
  result: SearchResult;
}

export const PageResultCard = ({ result }: PageResultCardProps) => {
  // TODO: Remove defensive checks once mock data is replaced with real API data
  // Handle both API data (nested) and mock data (flat) structures
  const pageDetails = result.pageDetails || {
    url: (result as any).url || '',
    title: (result as any).title || 'Untitled',
    description: (result as any).description || '',
  };

  return (
    <ResultCardLink to={pageDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <ResultCardHeader>
          <ResultCardTag>
            {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
            <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>Page</Badge>
          </ResultCardTag>
          <ResultCardTitle>{pageDetails.title}</ResultCardTitle>
          <ResultCardWebPage>
            <span className="break-all text-sm font-semibold underline">{pageDetails.url}</span>
          </ResultCardWebPage>
          <ResultCardDescription>
            <HighlightedText text={pageDetails.description} />
          </ResultCardDescription>
        </ResultCardHeader>
      </ResultCard>
    </ResultCardLink>
  );
};
